module.exports = __webpack_public_path__ + "img/medal-silver.86311e43.svg";